import type { GtmLeadStage } from '@laplace/contracts'

export type StageTone = 'neutral' | 'info' | 'good' | 'warn' | 'bad'

export const STAGE_TONE: Record<GtmLeadStage, StageTone> = {
  found: 'neutral',
  queued: 'info',
  contacted: 'info',
  no_reply: 'neutral',
  interested: 'good',
  objection: 'warn',
  not_now: 'warn',
  out_of_office: 'neutral',
  meeting_booked: 'good',
  meeting_held: 'good',
  won: 'good',
  lost: 'bad',
  not_interested: 'bad',
  bounced: 'bad',
  unsubscribed: 'bad',
}

export const TONE_CLASS: Record<StageTone, string> = {
  neutral: 'border-border text-muted-foreground',
  info: 'border-primary/40 text-primary',
  good: 'border-success/40 text-success',
  warn: 'border-warning/40 text-warning',
  bad: 'border-destructive/40 text-destructive',
}

/** Manual stage corrections; contacting a lead requires a real send. */
export const MARKABLE_STAGES: Array<GtmLeadStage> = [
  'queued',
  'interested',
  'objection',
  'not_now',
  'out_of_office',
  'meeting_booked',
  'meeting_held',
  'won',
  'lost',
  'not_interested',
  'bounced',
  'unsubscribed',
]
